// Project-wide design tokens.
// All styled components import from here — no hardcoded style values.
// When a ThemeProvider is set up, replace this import
// with useTheme() or styled(Comp)(({ theme }) => ({ ... })).

const BORDER_COLOR = '#d1d5db';
const BORDER_LIGHT = '#e5e7eb';

const theme = {
  colors: {
    primary: '#368007',
    primaryHover: '#2a6605',
    danger: '#dc2626',
    dangerBorder: '#fecaca',

    text: '#374151',
    textDark: '#1a1a1a',
    textBody: '#1f2937',
    textMuted: '#6b7280',
    textHint: '#9ca3af',

    border: BORDER_COLOR,
    borderLight: BORDER_LIGHT,

    bgPage: '#f3f4f6',
    bgCard: '#ffffff',
    bgMuted: '#f9fafb',

    badgeAm: '#fff3e0',
    badgeAmText: '#e65100',
    badgePm: '#e3f2fd',
    badgePmText: '#1565c0',

    focusRing: '#235a98',

    warning: '#ff9800',
    warningHover: '#ef6c00',
    warningText: '#f57c00',
    warningBg: '#fff3e0',
    dangerBg: '#fef2f2',
    disabled: '#9ca3af',

    white: '#ffffff',
    whiteOverlay: 'rgba(255,255,255,0.2)',
  },

  radii: {
    card: '12px',
    inner: '8px',
    input: '6px',
    pill: '12px',
    badge: '6px',
  },

  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600,
  },

  spacing: {
    // Page layout
    pagePadding: '32px 84px',
    cardPadding: '32px',
    sectionGap: '24px',
    fieldGap: '16px',
    headerPadding: '14px 24px',
    bodyPadding: '20px',

    // Component internals
    cellPadding: '12px 16px',
    inputPadding: '7px 10px',
    badgePadding: '2px 10px',
    smallBadgePadding: '2px 8px',
    buttonPadding: '12px 48px',
    smallButtonPadding: '6px 12px',
    addButtonPadding: '7px 16px',
    iconPadding: '4px',
    pillPadding: '3px 10px',
    emptyStatePadding: '40px',
    dropdownItemPadding: '12px 16px',

    // Gaps
    gapXs: '2px',
    gapSm: '4px',
    gapMd: '8px',
    gapLg: '10px',
    gapXl: '12px',

    // Small component paddings
    removeBtnPadding: '5px 14px',
    countInputPadding: '6px 10px',
    inputLabelGap: '6px',
    datePickerInnerPadding: '0 6px',
    datePickerInputPadding: '6px 4px',

    // Margins
    labelGap: '4px',
    hintGap: '3px',
    requiredGap: '2px',
    pageTitleMargin: '30px',
    dropdownOffset: '5px',
    trafficBodyPadding: '10px',
  },

  typography: {
    pageTitle: { fontSize: '28px', fontWeight: 600 },
    sectionTitle: { fontSize: '20px', fontWeight: 600 },
    sectionHeader: { fontSize: '15px', fontWeight: 600 },
    label: { fontSize: '13px', fontWeight: 500 },
    hint: { fontSize: '11px', fontWeight: 400 },
    body: { fontSize: '14px', fontWeight: 400 },
    button: { fontSize: '15px', fontWeight: 500 },
    smallButton: { fontSize: '13px', fontWeight: 500 },
    badge: { fontSize: '11px', fontWeight: 500 },
  },

  shadows: {
    card: '0 1px 3px rgba(0, 0, 0, 0.12)',
    buttonHover: '0 4px 8px rgba(54, 128, 7, 0.3)',
    dropdown: '0px 8px 16px 0px rgba(0,0,0,0.2)',
  },

  borders: {
    input: `1.5px solid ${BORDER_COLOR}`,
    card: `1px solid ${BORDER_LIGHT}`,
  },

  sizes: {
    icon: '14px',
    inputMinHeight: '34px',
    selectMinHeight: '40px',
    smallFontSize: '12px',
    tabMinWidth: '120px',
    filterFieldMinWidth: '200px',
    regionSelectWidth: '220px',
    marketSelectWidth: '280px',
  },

  transitions: {
    default: 'all 0.2s ease',
  },

  breakpoints: {
    mobile: '768px',
  },
};

export default theme;
